import PropTypes from 'prop-types';
import _ from 'lodash'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './assets/cardStyles.css';
import './assets/shareStyles.css';
import {
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Dropdown,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Tab,
  Input,
  Modal,
  Form,
  TextArea,
  Search,
  Comment,
  Label,
  Transition,
  Placeholder,
} from 'semantic-ui-react'

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
} from  'react-share';

import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";

import Footer from './Footer';

import firebase from './components/Firebase';

// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === 'undefined'

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
}

const db = firebase.firestore();

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container text>
    <Header
      as='h1'
      content='Looking for an Event ?'
      inverted
      style={{
        fontSize: mobile ? '2em' : '4em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '3em',
      }}
    />
    <Header
      as='h2'
      content='Explore & make your desired events visible with the help of our platform'
      inverted
      style={{
        fontSize: mobile ? '1.5em' : '1.7em',
        fontWeight: 'normal',
        marginTop: mobile ? '0.5em' : '1.5em',
      }}
    />
    <Button primary as={Link} to='/eventcreate' size='huge'>
      Create Event
      <Icon name='right arrow' />
    </Button>
  </Container>
)

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
}

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {}

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { children, user } = this.props
    const { fixed } = this.state
    const trigger = (
      <span>
        <Image avatar src={user ? user.profileImgUrl : 'https://react.semantic-ui.com/images/wireframe/image.png'} /> {user ? `${user.firstName} ${user.lastName}` : <Placeholder><Placeholder.Line/></Placeholder>}
      </span>
    );

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign='center'
            style={{ backgroundImage: `url('https://source.unsplash.com/random')`,
              backgroundSize: 'cover',
              backgroundAttachment: 'fixed',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              // opacity: 0.6,
              minHeight: 500,
              Zindex: 0,
            padding: '1em 0em' }}
            vertical
          >

            <Menu
              fixed={fixed ? 'top' : null}
              inverted={true}
              pointing={!fixed}
              secondary={!fixed}
              size='large'
              style={{ borderWidth: 0 }}
            >
              <Container>
                <Menu.Item header>Our Company</Menu.Item>
                <Menu.Item as='a' active>
                  Home
                </Menu.Item>
                <Menu.Item as={Link} to='/eventcreate'>Create an Event</Menu.Item>
                <Menu.Item as={Link} to='/venues'>Venues</Menu.Item>
                <Menu.Item as={Link} to='/registervenue'>Register a Venue</Menu.Item>
                <Menu.Item position='right'>
                  { user ?
                    ([(<Dropdown trigger={trigger} icon="null" pointing='top left' pointing>
                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to='/profile'><Icon name='user'/>Profile</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/notifications'><Icon name='feed'/>Notifications</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>),
                      (<Button as='a' inverted={!fixed} onClick={this.handleSignOut} secondary icon labelPosition='left'>
                        <Icon name='power off'/>
                        Logout
                      </Button>)])
                  :
                  [(<Button as={Link} to='login' inverted={!fixed}>
                    Log in
                  </Button>),
                    (<Button as={Link} to='signup' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                      Sign Up
                    </Button>)]
                  }
                </Menu.Item>
              </Container>
            </Menu>
            <HomepageHeading />
          </Segment>
        </Visibility>

        {children}
      </Responsive>
    )
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
  user: PropTypes.array,
}

class MobileContainer extends Component {
  state = {}

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const { children, user } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation='scale down'
          icon='labeled'
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item header>Our Company</Menu.Item>
          <Menu.Item as='a' active>
            Home
          </Menu.Item>
          <Menu.Item as={Link} to='/eventcreate'>Create an Event</Menu.Item>
          <Menu.Item as={Link} to='/venues'>Venues</Menu.Item>
          <Menu.Item as={Link} to='/registervenue'>Register a Venue</Menu.Item>
          {user ?
            (
              [(<Menu.Item as={Link} to='/profile'>Profile</Menu.Item>),
              (<Menu.Item as={Link} to='/notifications'>Notifications</Menu.Item>),
              (<Menu.Item as='a' onClick={this.handleSignOut}>Logout</Menu.Item>)]
            )
          :
          ([(<Menu.Item as={Link} to='/login'>Log in</Menu.Item>),
            (<Menu.Item as={Link} to='/signup'>Sign Up</Menu.Item>)])
          }
          <Menu.Item as='a' onClick={this.handleSidebarHide}><Icon name='close'/></Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            style={{ backgroundImage: `url('https://source.unsplash.com/random')`,
                backgroundSize: 'cover',
                Zindex: -2,
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                // opacity: 0.6,
                minHeight: 350,
            padding: '1em 0em' }}
            vertical
          >

            <Container style={{ 	backgroundColor: "#333333",
              opacity: 0.6,
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            Zindex: -2 }}>
              <Container>
                <Menu inverted pointing secondary size='large' style={{ borderWidth: 0 }}>
                  <Menu.Item onClick={this.handleToggle}>
                    <Icon name='sidebar' />
                  </Menu.Item>
                  <Menu.Item position='right'>
                    {user ?
                      (<span>
                        <Image avatar src={user ? user.profileImgUrl : 'https://react.semantic-ui.com/images/wireframe/image.png'} /> {user ? `${user.firstName} ${user.lastName}` : <Placeholder><Placeholder.Line/></Placeholder>}
                      </span>)
                    :
                    ([<Button as={Link} to='/login' inverted>
                      Log in
                    </Button>],
                      [<Button as={Link} to='/signup' inverted style={{ marginLeft: '0.5em' }}>
                        Sign Up
                      </Button>])
                    }
                  </Menu.Item>
                </Menu>
              </Container>
              <HomepageHeading mobile />
            </Container>
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
  user: PropTypes.array,
}

const ResponsiveContainer = ({ children, user }) => {
  return(
  <div>
    <DesktopContainer user={user}>{children}</DesktopContainer>
    <MobileContainer user={user}>{children}</MobileContainer>
  </div>
);
}

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
  user: PropTypes.any,
}



export default function Home(props) {

  const [events, setEvents] = React.useState([]);
  const [eventsByCategory, setEventsByCategory] = React.useState({});
  const [categories, setCategories] = React.useState([]);
  const [date, setDate] = React.useState(new Date());
  const [searchLoader, setSearchLoader] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const [searchResults, setResults] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [user, setUser] = React.useState(firebase.auth().currentUser);
  const [country, setCountry] = React.useState();
  const openAPI = 'https://api.opencagedata.com/geocode/v1/json?q=';
  const openAPIKey = '&key=d1fa4a4fbb644417abc4d1995efff843';

  const getUserLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      console.log(position);
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      var geoUrl = openAPI + `${lat}+${lng}` + openAPIKey + '&pretty=1' + '&no_annotations=1';
      getStringLocation(geoUrl);
    });
  }

  const getStringLocation = async (geoUrl) => {
    var result = await axios(geoUrl);
    console.log(result.data.results);
    var location = result.data.results[0].components;
    setCountry(location.country);
    console.log(location.country);
  }

  const handleCountry = (e, {value}) => {
    setCountry(value);
  }

  const getEvents = async () => {
    var eventsRef = await db.collection("Events");
    if (country){
      eventsRef.where("eventCountry", "==", country).where("formattedEndDate", ">=", date).get().then(querySnapshot => {
          let events = [];
          querySnapshot.forEach(doc =>
            events.push({ ...doc.data() })
          )
          setEvents(events);
          groupEventsByCategory(events);
          console.log(date);
      });
    }
  }

  React.useEffect(() => {
    firebase.auth().onAuthStateChanged(function(user){
      if (user) {
        db.collection("Users").doc(user.uid).get().then(doc => {
          if (doc.exists){
            setUser(doc.data());
          }
          else {
            setUser(null);
          }
        })
      }
      else {
        setUser(null);
      }
  });
  if (country === undefined) {
    getUserLocation();
  }
  getEvents();
  setTimeout(() => {
    setLoading(false);
  }, 3000);
}, [country]);


  const groupEventsByCategory = (events) => {
    let eventsGroupedByCategory = {}
    events.forEach(event => {
      if (eventsGroupedByCategory[event.eventCategory] == undefined) {
        eventsGroupedByCategory[event.eventCategory] = [];
      }
      eventsGroupedByCategory[event.eventCategory].push(event);
    })
    const categories = Object.keys(eventsGroupedByCategory);
    console.log(categories);
    setCategories(categories);
    console.log(eventsGroupedByCategory);
    setEventsByCategory(eventsGroupedByCategory);
    return eventsGroupedByCategory;
  }

  const trimString = function (string, length) {
      return string.length > length ?
             string.substring(0, length) + '...' :
             string;
    };


  const resultRenderer = ({ eventName, eventImgUrl, eventDetails, uid }) =>

    <List.Item as={Link} to={`event/${uid}`}>
      <Image avatar src={eventImgUrl}/>
      <List.Content>
        <List.Header as='a'>{eventName}</List.Header>
        <List.Description>
          {trimString(eventDetails, 60)}
        </List.Description>
      </List.Content>
    </List.Item>

  const handleResultSelect = (e, {result}) => {
    setSearchValue(result.eventName);
  }

  function setInitialValues() {
    // setSearchValue('');
    setSearchLoader(false);
    setResults([]);
  }

  const handleSearchChange = (e, {value}) => {
    setSearchLoader(true);
    setSearchValue(value);
    setTimeout(() => {
      if (searchValue.length < 0) return setInitialValues();
      const re = new RegExp(_.escapeRegExp(searchValue), 'i');
      const isMatch = (result) => re.test(result.eventName);
      setSearchLoader(false);
      setResults(_.filter(events, isMatch));
    }, 300);
  }
    const categoryPanes = categories.map(category => {
      return {
        menuItem: category,
        render: () => <Segment padded raised><EventMedia events={eventsByCategory[category]} user={user} loading={loading}/></Segment>
      }
    })

    const panes = [
      {
        menuItem: 'All Events',
        render: () => <Segment padded raised><EventMedia events={events} user={user} loading={loading}/></Segment>,
      },
      ...categoryPanes
    ]

    const countryOptions = [
  { key: 'null', value: 'null', flag: '', text: '' },
  { key: 'af', value: 'Afghanistan', flag: 'af', text: 'Afghanistan' },
  { key: 'ax', value: 'Aland Islands', flag: 'ax', text: 'Aland Islands' },
  { key: 'al', value: 'Albania', flag: 'al', text: 'Albania' },
  { key: 'dz', value: 'Algeria', flag: 'dz', text: 'Algeria' },
  { key: 'as', value: 'American Samoa', flag: 'as', text: 'American Samoa' },
  { key: 'ad', value: 'Andorra', flag: 'ad', text: 'Andorra' },
  { key: 'ao', value: 'Angola', flag: 'ao', text: 'Angola' },
  { key: 'ai', value: 'Anguilla', flag: 'ai', text: 'Anguilla' },
  { key: 'ag', value: 'Antigua', flag: 'ag', text: 'Antigua' },
  { key: 'ar', value: 'Argentina', flag: 'ar', text: 'Argentina' },
  { key: 'am', value: 'Armenia', flag: 'am', text: 'Armenia' },
  { key: 'aw', value: 'Aruba', flag: 'aw', text: 'Aruba' },
  { key: 'au', value: 'Australia', flag: 'au', text: 'Australia' },
  { key: 'at', value: 'Austria', flag: 'at', text: 'Austria' },
  { key: 'az', value: 'Azerbaijan', flag: 'az', text: 'Azerbaijan' },
  { key: 'bs', value: 'Bahamas', flag: 'bs', text: 'Bahamas' },
  { key: 'bh', value: 'Bahrain', flag: 'bh', text: 'Bahrain' },
  { key: 'bd', value: 'Bangladesh', flag: 'bd', text: 'Bangladesh' },
  { key: 'bb', value: 'Barbados', flag: 'bb', text: 'Barbados' },
  { key: 'by', value: 'Belarus', flag: 'by', text: 'Belarus' },
  { key: 'be', value: 'Belgium', flag: 'be', text: 'Belgium' },
  { key: 'bz', value: 'Belize', flag: 'bz', text: 'Belize' },
  { key: 'bj', value: 'Benin', flag: 'bj', text: 'Benin' },
  { key: 'bm', value: 'Bermuda', flag: 'bm', text: 'Bermuda' },
  { key: 'bt', value: 'Bhutan', flag: 'bt', text: 'Bhutan' },
  { key: 'bo', value: 'Bolivia', flag: 'bo', text: 'Bolivia' },
  { key: 'ba', value: 'Bosnia', flag: 'ba', text: 'Bosnia' },
  { key: 'bw', value: 'Botswana', flag: 'bw', text: 'Botswana' },
  { key: 'br', value: 'Brazil', flag: 'br', text: 'Brazil' },
  { key: 'bg', value: 'Bulgaria', flag: 'bg', text: 'Bulgaria' },
  { key: 'bf', value: 'Burkina Faso', flag: 'bf', text: 'Burkina Faso' },
  { key: 'bi', value: 'Burundi', flag: 'bi', text: 'Burundi' },
  { key: 'tc', value: 'Caicos Islands', flag: 'tc', text: 'Caicos Islands' },
  { key: 'kh', value: 'Cambodia', flag: 'kh', text: 'Cambodia' },
  { key: 'cm', value: 'Cameroon', flag: 'cm', text: 'Cameroon' },
  { key: 'ca', value: 'Canada', flag: 'ca', text: 'Canada' },
  { key: 'cv', value: 'Cape Verde', flag: 'cv', text: 'Cape Verde' },
  { key: 'ky', value: 'Cayman Islands', flag: 'ky', text: 'Cayman Islands' },
  { key: 'cf', value: 'Central African Republic', flag: 'cf', text: 'Central African Republic' },
  { key: 'td', value: 'Chad', flag: 'td', text: 'Chad' },
  { key: 'cl', value: 'Chile', flag: 'cl', text: 'Chile' },
  { key: 'cn', value: 'China', flag: 'cn', text: 'China' },
  { key: 'co', value: 'Colombia', flag: 'co', text: 'Colombia' },
  { key: 'km', value: 'Comoros', flag: 'km', text: 'Comoros' },
  { key: 'cd', value: 'Congo', flag: 'cd', text: 'Congo' },
  { key: 'cg', value: 'Congo Brazzaville', flag: 'cg', text: 'Congo Brazzaville' },
  { key: 'cr', value: 'Costa Rica', flag: 'cr', text: 'Costa Rica' },
  { key: 'ci', value: "Cote D'Ivoire", flag: 'ci', text: "Cote D'Ivoire" },
  { key: 'hr', value: 'Croatia', flag: 'hr', text: 'Croatia' },
  { key: 'cu', value: 'Cuba', flag: 'cu', text: 'Cuba' },
  { key: 'cy', value: 'Cyprus', flag: 'cy', text: 'Cyprus' },
  { key: 'cz', value: 'Czech Republic', flag: 'cz', text: 'Czech Republic' },
  { key: 'dk', value: 'Denmark', flag: 'dk', text: 'Denmark' },
  { key: 'dj', value: 'Djibouti', flag: 'dj', text: 'Djibouti' },
  { key: 'do', value: 'Dominican Republic', flag: 'do', text: 'Dominican Republic' },
  { key: 'eu', value: 'Ecuador', flag: 'ec', text: 'Ecuador' },
  { key: 'eg', value: 'Egypt', flag: 'eg', text: 'Egypt' },
  { key: 'sv', value: 'El Salvador', flag: 'sv', text: 'El Salvador' },
  { key: 'gq', value: 'Equatorial Guinea', flag: 'gq', text: 'Equatorial Guinea' },
  { key: 'ee', value: 'Estonia', flag: 'ee', text: 'Estonia' },
  { key: 'er', value: 'Eritrea', flag: 'er', text: 'Eritrea' },
  { key: 'et', value: 'Ethiopia', flag: 'et', text: 'Ethiopia' },
  { key: 'fo', value: 'Faroe Islands', flag: 'fo', text: 'Faroe Islands' },
  { key: 'fj', value: 'Fiji', flag: 'fj', text: 'Fiji' },
  { key: 'fi', value: 'Finland', flag: 'fi', text: 'Finland' },
  { key: 'fr', value: 'France', flag: 'fr', text: 'France' },
  { key: 'gf', value: 'French Guiana', flag: 'gf', text: 'French Guiana' },
  { key: 'pf', value: 'French Polynesia', flag: 'pf', text: 'French Polynesia' },
  { key: 'tf', value: 'French Territories', flag: 'tf', text: 'French Territories' },
  { key: 'ga', value: 'Gabon', flag: 'ga', text: 'Gabon' },
  { key: 'gm', value: 'Gambia', flag: 'gm', text: 'Gambia' },
  { key: 'ge', value: 'Georgia', flag: 'ge', text: 'Georgia' },
  { key: 'de', value: 'Germany', flag: 'de', text: 'Germany' },
  { key: 'gh', value: 'Ghana', flag: 'gh', text: 'Ghana' },
  { key: 'gr', value: 'Greece', flag: 'gr', text: 'Greece' },
  { key: 'gl', value: 'Greenland', flag: 'gl', text: 'Greenland' },
  { key: 'gd', value: 'Grenada', flag: 'gd', text: 'Grenada' },
  { key: 'gp', value: 'Guadeloupe', flag: 'gp', text: 'Guadeloupe' },
  { key: 'gt', value: 'Guatemala', flag: 'gt', text: 'Guatemala' },
  { key: 'gn', value: 'Guinea', flag: 'gn', text: 'Guinea' },
  { key: 'gw', value: 'Guinea-Bissau', flag: 'gw', text: 'Guinea-Bissau' },
  { key: 'gy', value: 'Guyana', flag: 'gy', text: 'Guyana' },
  { key: 'ht', value: 'Haiti', flag: 'ht', text: 'Haiti' },
  { key: 'hn', value: 'Honduras', flag: 'hn', text: 'Honduras' },
  { key: 'hk', value: 'Hong Kong', flag: 'hk', text: 'Hong Kong' },
  { key: 'hu', value: 'Hungary', flag: 'hu', text: 'Hungary' },
  { key: 'is', value: 'Iceland', flag: 'is', text: 'Iceland' },
  { key: 'in', value: 'India', flag: 'in', text: 'India' },
  { key: 'id', value: 'Indonesia', flag: 'id', text: 'Indonesia' },
  { key: 'ir', value: 'Iran', flag: 'ir', text: 'Iran' },
  { key: 'iq', value: 'Iraq', flag: 'iq', text: 'Iraq' },
  { key: 'ie', value: 'Ireland', flag: 'ie', text: 'Ireland' },
  { key: 'il', value: 'Israel', flag: 'il', text: 'Israel' },
  { key: 'il', value: 'Italy', flag: 'it', text: 'Italy' },
  { key: 'jm', value: 'Jamaica', flag: 'jm', text: 'Jamaica' },
  { key: 'jp', value: 'Japan', flag: 'jp', text: 'Japan' },
  { key: 'jo', value: 'Jordan', flag: 'jo', text: 'Jordan' },
  { key: 'kz', value: 'Kazakhstan', flag: 'kz', text: 'Kazakhstan' },
  { key: 'ke', value: 'Kenya', flag: 'ke', text: 'Kenya' },
  { key: 'kw', value: 'Kuwait', flag: 'kw', text: 'Kuwait' },
  { key: 'lv', value: 'Latvia', flag: 'lv', text: 'Latvia' },
  { key: 'lb', value: 'Lebanon', flag: 'lb', text: 'Lebanon' },
  { key: 'ls', value: 'Lesotho', flag: 'ls', text: 'Lesotho' },
  { key: 'lr', value: 'Liberia', flag: 'lr', text: 'Liberia' },
  { key: 'ly', value: 'Libya', flag: 'ly', text: 'Libya' },
  { key: 'li', value: 'Liechtenstein', flag: 'li', text: 'Liechtenstein' },
  { key: 'lt', value: 'Lithuania', flag: 'lt', text: 'Lithuania' },
  { key: 'lu', value: 'Luxembourg', flag: 'lu', text: 'Luxembourg' },
  { key: 'mk', value: 'Macedonia', flag: 'mk', text: 'Macedonia' },
  { key: 'mg', value: 'Madagascar', flag: 'mg', text: 'Madagascar' },
  { key: 'mw', value: 'Malawi', flag: 'mw', text: 'Malawi' },
  { key: 'my', value: 'Malaysia', flag: 'my', text: 'Malaysia' },
  { key: 'mv', value: 'Maldives', flag: 'mv', text: 'Maldives' },
  { key: 'ml', value: 'Mali', flag: 'ml', text: 'Mali' },
  { key: 'mt', value: 'Malta', flag: 'mt', text: 'Malta' },
  { key: 'mq', value: 'Martinique', flag: 'mq', text: 'Martinique' },
  { key: 'mr', value: 'Mauritania', flag: 'mr', text: 'Mauritania' },
  { key: 'mu', value: 'Mauritius', flag: 'mu', text: 'Mauritius' },
  { key: 'mx', value: 'Mexico', flag: 'mx', text: 'Mexico' },
  { key: 'md', value: 'Moldova', flag: 'md', text: 'Moldova' },
  { key: 'mc', value: 'Monaco', flag: 'mc', text: 'Monaco' },
  { key: 'mn', value: 'Mongolia', flag: 'mn', text: 'Mongolia' },
  { key: 'me', value: 'Montenegro', flag: 'me', text: 'Montenegro' },
  { key: 'ma', value: 'Morocco', flag: 'ma', text: 'Morocco' },
  { key: 'mz', value: 'Mozambique', flag: 'mz', text: 'Mozambique' },
  { key: 'na', value: 'Namibia', flag: 'na', text: 'Namibia' },
  { key: 'np', value: 'Nepal', flag: 'np', text: 'Nepal' },
  { key: 'nl', value: 'Netherlands', flag: 'nl', text: 'Netherlands' },
  { key: 'pg', value: 'New Guinea', flag: 'pg', text: 'New Guinea' },
  { key: 'nz', value: 'New Zealand', flag: 'nz', text: 'New Zealand' },
  { key: 'ni', value: 'Nicaragua', flag: 'ni', text: 'Nicaragua' },
  { key: 'ne', value: 'Niger', flag: 'ne', text: 'Niger' },
  { key: 'ng', value: 'Nigeria', flag: 'ng', text: 'Nigeria' },
  { key: 'kp', value: 'North Korea', flag: 'kp', text: 'North Korea' },
  { key: 'no', value: 'Norway', flag: 'no', text: 'Norway' },
  { key: 'pk', value: 'Pakistan', flag: 'pk', text: 'Pakistan' },
  { key: 'ps', value: 'Palestine', flag: 'ps', text: 'Palestine' },
  { key: 'pa', value: 'Panama', flag: 'pa', text: 'Panama' },
  { key: 'py', value: 'Paraguay', flag: 'py', text: 'Paraguay' },
  { key: 'py', value: 'Paraguay', flag: 'py', text: 'Paraguay' },
  { key: 'pe', value: 'Peru', flag: 'pe', text: 'Peru' },
  { key: 'ph', value: 'Philippines', flag: 'ph', text: 'Philippines' },
  { key: 'pl', value: 'Poland', flag: 'pl', text: 'Poland' },
  { key: 'pt', value: 'Portugal', flag: 'pt', text: 'Portugal' },
  { key: 'pr', value: 'Puerto Rico', flag: 'pr', text: 'Puerto Rico' },
  { key: 'qa', value: 'Qatar', flag: 'qa', text: 'Qatar' },
  { key: 'ro', value: 'Romania', flag: 'ro', text: 'Romania' },
  { key: 'ru', value: 'Russia', flag: 'ru', text: 'Russia' },
  { key: 'rw', value: 'Rwanda', flag: 'rw', text: 'Rwanda' },
  { key: 'ws', value: 'Samoa', flag: 'ws', text: 'Samoa' },
  { key: 'st', value: 'Sao Tome', flag: 'st', text: 'Sao Tome' },
  { key: 'sa', value: 'Saudi Arabia', flag: 'sa', text: 'Saudi Arabia' },
  { key: 'gb sct', value: 'Scotland', flag: 'gb sct', text: 'Scotland' },
  { key: 'sn', value: 'Senegal', flag: 'sn', text: 'Senegal' },
  { key: 'cs', value: 'Serbia', flag: 'cs', text: 'Serbia' },
  { key: 'sc', value: 'Seychelles', flag: 'sc', text: 'Seychelles' },
  { key: 'sl', value: 'Sierra Leone', flag: 'sl', text: 'Sierra Leone' },
  { key: 'sg', value: 'Singapore', flag: 'sg', text: 'Singapore' },
  { key: 'sk', value: 'Slovakia', flag: 'sk', text: 'Slovakia' },
  { key: 'si', value: 'Slovenia', flag: 'si', text: 'Slovenia' },
  { key: 'so', value: 'Somalia', flag: 'so', text: 'Somalia' },
  { key: 'za', value: 'South Africa', flag: 'za', text: 'South Africa' },
  { key: 'kr', value: 'South Korea', flag: 'kr', text: 'South Korea' },
  { key: 'es', value: 'Spain', flag: 'es', text: 'Spain' },
  { key: 'lk', value: 'Sri Lanka', flag: 'lk', text: 'Sri Lanka' },
  { key: 'sd', value: 'Sudan', flag: 'sd', text: 'Sudan' },
  { key: 'sr', value: 'Suriname', flag: 'sr', text: 'Suriname' },
  { key: 'sz', value: 'Swaziland', flag: 'sz', text: 'Swaziland' },
  { key: 'se', value: 'Sweden', flag: 'se', text: 'Sweden' },
  { key: 'ch', value: 'Switzerland', flag: 'ch', text: 'Switzerland' },
  { key: 'sy', value: 'Syria', flag: 'sy', text: 'Syria' },
  { key: 'tw', value: 'Taiwan', flag: 'tw', text: 'Taiwan' },
  { key: 'tz', value: 'Tanzania', flag: 'tz', text: 'Tanzania' },
  { key: 'th', value: 'Thailand', flag: 'th', text: 'Thailand' },
  { key: 'tg', value: 'Togo', flag: 'tg', text: 'Togo' },
  { key: 'tt', value: 'Trinidad', flag: 'tt', text: 'Trinidad' },
  { key: 'tn', value: 'Tunisia', flag: 'tn', text: 'Tunisia' },
  { key: 'tr', value: 'Turkey', flag: 'tr', text: 'Turkey' },
  { key: 'ae', value: 'U.A.E', flag: 'ae', text: 'U.A.E' },
  { key: 'ug', value: 'Uganda', flag: 'ug', text: 'Uganda' },
  { key: 'ua', value: 'Ukraine', flag: 'ua', text: 'Ukraine' },
  { key: 'uk', value: 'United Kingdom', flag: 'uk', text: 'United Kingdom' },
  { key: 'us', value: 'United States', flag: 'us', text: 'United States' },
  { key: 'uy', value: 'Uruguay', flag: 'uy', text: 'Uruguay' },
  { key: 'uz', value: 'Uzbekistan', flag: 'uz', text: 'Uzbekistan' },
  { key: 've', value: 'Venezuela', flag: 've', text: 'Venezuela' },
  { key: 'vn', value: 'Vietnam', flag: 'vn', text: 'Vietnam' },
  { key: 'gb wls', value: 'Wales', flag: 'gb wls', text: 'Wales' },
  { key: 'ye', value: 'Yemen', flag: 'ye', text: 'Yemen' },
  { key: 'zm', value: 'Zambia', flag: 'zm', text: 'Zambia' },
  { key: 'zw', value: 'Zimbabwe', flag: 'zw', text: 'Zimbabwe' },
]

  return (
  <ResponsiveContainer user={user}>
    <Segment style={{ padding: '8em 0em' }} raised vertical>
      <Grid container stackable columns='equal' centered textAlign='center'>
        <Grid.Row columns={12}>
          <Search
            fluid
            placeholder='Search for nearby events'
            size='large'
            loading={searchLoader}
            onResultSelect={handleResultSelect}
            onSearchChange={_.debounce(handleSearchChange, 500, {
              trailing: true,
            })}
            results={searchResults}
            resultRenderer={resultRenderer}
            value={searchValue}
            className='search_bar'
            {...props}
          />
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            {country ? (<Dropdown
              inline
              search
              placeholder={country}
              value={country}
              onChange={handleCountry}
              options={countryOptions}/>) :
              (<Dropdown
                inline
                search
                placeholder='Select country'
                value={country}
                onChange={handleCountry}
                options={countryOptions}/>)}
          </Grid.Column>
          <Grid.Column>
            <Modal
              trigger={
                <Button floated='right' secondary icon>
                  <Icon name='sort amount down'/> Sort Events
                </Button>
              }
              closeIcon
            >
              <Modal.Header>Sort Events</Modal.Header>
              {/* <Modal.Content>
                <Modal.Desription></Modal.Desription>
              </Modal.Content> */}
            </Modal>
          </Grid.Column>
        </Grid.Row>
        {events.length > 0 ? (<Tab menu={{ secondary: true, pointing: true }} panes={panes}/>) : (<Segment>There are no upcoming events in this country at the moment</Segment>)}
      </Grid>
    </Segment>
    <Footer/>
  </ResponsiveContainer>
);
}

EventMedia.propTypes = {
  user: PropTypes.any.isRequired,
  events: PropTypes.array.isRequired,
}

function EventMedia(props){
  const {events, user} = props
  const [date, setDate] = React.useState(new Date());
  const [loading, setLoading] = React.useState(true);

  var lengthString = 50;

  let trimString = function (string, length) {
      return string.length > length ?
             string.substring(0, length) + '...' :
             string;
    };

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  return(
      <Card.Group centered items={events.count}>
        {events.map(event => (
          (<Modal
            trigger={
              <Card link>
                {loading ?
                  (
                    <Placeholder className='event_card_image'>
                      <Placeholder.Image rectangular className='event_card_image'/>
                    </Placeholder> )
                :
                (<Image className='event_card_image' src={event.eventImgUrl} wrapped ui={false} size='small' />)
                }
                <Card.Content>
                  {loading ?
                    (<Placeholder>
                      <Placeholder.Header>
                        <Placeholder.Line length='very short' />
                        <Placeholder.Line length='medium' />
                      </Placeholder.Header>
                    </Placeholder>)
                  :
                  (
                    [(<Card.Header>{trimString(event.eventName, 30)}</Card.Header>),
                    (<Card.Meta>
                      <span className='date'>{event.startDate}</span>
                    </Card.Meta>)]
                  )
                  }
                  <Card.Description className='event_card_description'>
                    {loading ?
                      (<Placeholder>
                        <Placeholder.Paragraph>
                          <Placeholder.Line/>
                          <Placeholder.Line/>
                        </Placeholder.Paragraph>
                      </Placeholder>)
                    :
                    (
                      [(<p>{trimString(event.eventDetails.blocks[0].text, lengthString)}</p>),
                      (<p>{trimString(`${event.eventStreet1}, ${event.eventCity}, ${event.eventCountry}`, lengthString)}</p>)]
                    ) }
                  </Card.Description>
                </Card.Content>
                <Card.Content extra>
                  {loading ?
                    (<Placeholder fluid>
                      <Placeholder.Line/>
                    </Placeholder>)
                  :
                  (<CardDetails event={event}/>)
                  }
                </Card.Content>
              </Card>
            }
            closeIcon
           >
            <Modal.Header>{event.eventName}</Modal.Header>
            <Modal.Content image scrolling>
              <Image wrapped src={event.eventImgUrl} rounded className='modal_event_image'/>
              <Modal.Description>
                <Grid container stackable double>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <EventActions uid={event.uid} title={event.eventName} user={user}/>
                    </Grid.Column>
                    <Grid.Column>
                      <Button primary as={Link} to={`/event/${event.uid}`}>
                        Event Page
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Header>
                  <Icon name='calendar alternate outline' color='grey'/>
                  <Header.Content>Date & Time</Header.Content>
                </Header>
                <p>{event.startDate} @ {event.startTime} - {event.endDate} @ {event.endTime}</p>
                <Divider/>
                <Header>
                  <Icon name='map pin' color='grey'/>
                  <Header.Content>Event Address</Header.Content>
                  <Header.Subheader>
                  </Header.Subheader>
                </Header>
                <p>{event.eventVenue}, {event.eventStreet1}</p>
                <p>{event.eventCity}, {event.eventProvince}</p>
                <p>{event.eventCountry}</p>
              </Modal.Description>
            </Modal.Content>
          </Modal>)
        ))}
      </Card.Group>
  );

}

EventActions.propTypes = {
  uid: PropTypes.any.isRequired,
  title: PropTypes.any.isRequired,
  user: PropTypes.any.isRequired,
}

function EventActions(props) {
  const {uid, title, user} = props;
  const [active, setActive] = React.useState(false);
  const [values, setValues] = React.useState({
    comment: '',
  });
  const [date, setDate] = React.useState(new Date());
  const [loader, setLoader] = React.useState(false);
  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
  };
  const getLikeStatus = async () => {
    if (user) {
      const likeRef = await db.collection("Events").doc(uid).collection("eventLikeIDs").doc(user.uid);
      likeRef.onSnapshot((doc) => {
        if (doc.exists) {
          var like = doc.data().likeState;
          setActive(like);
        }
        else {
          db.collection("Events").doc(uid).collection("eventLikeIDs").doc(user.uid).set({
            likeState: false
          })
        }
      });
    }
  }
  React.useEffect(() => {
    getLikeStatus();
  }, []);
  const handleLikeClick = (e) => {
    setActive(!active);
    const counterRef = db.collection("Events").doc(uid).collection("eventLikes").doc(uid).collection("shards").doc('0');
    const likeStateRef = db.collection("Events").doc(uid).collection("eventLikeIDs").doc(user.uid);
    const batch = db.batch();
    if (!active) {
      console.log("Liked");
      batch.set(counterRef, {count: firebase.firestore.FieldValue.increment(1)}, {merge: true});
      batch.update(likeStateRef, {likeState: true});
      batch.commit();
      // incrementCounter(db, counterRef, 0);
      console.log("Liked");
    }
    else {
      console.log("Disliked");
      batch.set(counterRef, {count: firebase.firestore.FieldValue.increment(-1)}, {merge: true});
      batch.update(likeStateRef, {likeState: false});
      batch.commit();
      // decrementCounter(db, counterRef, 0);
      console.log("Disliked");
    }
  }

  const postComment = (e) => {
    if (user) {
      e.preventDefault();
      setLoader(true);
      const commentRef = db.collection("Events").doc(uid).collection("comments").doc();
      const commentStatRef = db.collection("Events").doc(uid).collection("statistics").doc("comments");
      const batch = db.batch();
      batch.set(commentRef, {
        message: values.comment,
        profileImgUrl: user.profileImgUrl,
        senderId: user.uid,
        username: user.username,
        timestamp: date,
      });
      batch.set(commentStatRef, {count: firebase.firestore.FieldValue.increment(1)}, {merge: true});
      batch.commit().then(() => {
        setLoader(false);
        setValues({
          comment: '',
        });
      });
    }
  }

  function createCounter(ref, num_shards) {
    var batch = db.batch();

    // Initialize the counter document
    batch.set(ref, { num_shards: num_shards });
    console.log('Breakpoint 1');

    // Initialize each shard with count=0
    for (let i = 0; i <= num_shards; i++) {
      console.log('Breakpoint 2');
        let shardRef = ref.collection('shards').doc(i.toString());
        batch.set(shardRef, { count: 0 });
    }

    // Commit the write batch
    return batch.commit();
  }

  function incrementCounter(db, ref, num_shards) {
    // Select a shard of the counter at random
    const shard_id = Math.floor(Math.random() * num_shards).toString();
    const shard_ref = ref.collection('shards').doc(shard_id);

    // Update count
    return shard_ref.update("count", firebase.firestore.FieldValue.increment(1));
  }

  function decrementCounter(db, ref, num_shards) {
    // Select a shard of the counter at random
    const shard_id = Math.floor(Math.random() * num_shards).toString();
    const shard_ref = ref.collection('shards').doc(shard_id);

    // Update count
    return shard_ref.update("count", firebase.firestore.FieldValue.increment(-1));
  }
  const shareURL = window.location.origin + '/event/' + uid;
  return (
    [<Button.Group icon>
      <Button toggle active={active} onClick={handleLikeClick} value={uid}>
        <Icon name='heart'/>
      </Button>
      (<Modal
        trigger={
          <Button>
            <Icon name='share alternate'/>
          </Button>
        }
        size='mini'
        closeIcon
       >
        <Modal.Header>Share Event</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            <div className='Share__container'>
              <div className='Share__some-network'>
                <FacebookShareButton url={shareURL} title={title} className='Share__some-network__share-button'>
                  <FacebookIcon
                    size={32}
                  round />
                </FacebookShareButton>
              </div>
              <div className='Share__some-network'>
                <TwitterShareButton url={shareURL} title={title} className='Share__some-network__share-button'>
                  <TwitterIcon
                    size={32}
                  round/>
                </TwitterShareButton>
              </div>
              <div className='Share__some-network'>
                <WhatsappShareButton url={shareURL} title={title} className='Share__some-network__share-button'>
                  <WhatsappIcon
                    size={32}
                  round/>
                </WhatsappShareButton>
              </div>
              <div className='Share__some-network'>
                <EmailShareButton url={shareURL} title={title} className='Share__some-network__share-button'>
                  <EmailIcon
                    size={32}
                  round/>
                </EmailShareButton>
              </div>
            </div>
          </Modal.Description>
        </Modal.Content>
      </Modal>),
      (<Modal
        trigger={
          <Button>
            <Icon name='chat'/>
          </Button>
        }
        closeIcon
       >
        <Modal.Header>Comments</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            <Comment.Group>
              <Chats uid={uid} user={user}/>
              <Form reply loading={loader} onSubmit={postComment}>
                <Form.TextArea placeholder='Add a comment or reply' value={values.comment} onChange={handleChange('comment')} name='comment' required/>
                <Button content='Add Reply' labelPosition='left' icon='edit' primary type='submit'/>
              </Form>
              <Divider hidden/>
            </Comment.Group>
          </Modal.Description>
        </Modal.Content>
      </Modal>)
    </Button.Group>]
  );
}

Chats.propTypes = {
  uid: PropTypes.any.isRequired,
  user: PropTypes.any,
}

function Chats(props) {
  const {uid, user} = props
  const [comments, setComments] = React.useState([]);
  React.useEffect(() => {
    db.collection('Events').doc(uid).collection('comments').onSnapshot(querySnapshot => {
      let messages = [];
      querySnapshot.forEach(doc =>
        messages.push({ ...doc.data() })
      )
      console.log(messages);
      setComments(messages);
    })
  }, [])
  return (
      comments.map(comment => (
          <Comment>
            <Comment.Avatar src={comment.profileImgUrl} />
            <Comment.Content>
              <Comment.Author as='a'>{comment.username}</Comment.Author>
              <Comment.Metadata>
                <div>{new Date(comment.timestamp.toDate()).toDateString()}</div>
              </Comment.Metadata>
              <Comment.Text>{comment.message}</Comment.Text>
            </Comment.Content>
          </Comment>
        ))
  );
}

CardDetails.propTypes = {
  event: PropTypes.any.isRequired,
}

function CardDetails(props){
  const {event} = props
  const likeRef = db.collection("Events").doc(event.uid).collection("eventLikes").doc(event.uid).collection("shards").doc('0');
  const commRef = db.collection("Events").doc(event.uid).collection("statistics").doc("comments");
  const [eventLikes, setEventLikes] = React.useState(0);
  const [comments, setComments] = React.useState(0);
  const getLikesCount = e => {
    likeRef.onSnapshot((doc) => {
      if (doc.exists) {
        var likeCount = doc.data().count
        setEventLikes(likeCount)
      }
      else {
        createCounter(db.collection("Events").doc(event.uid).collection("eventLikes").doc(event.uid), 0)
      }
    });
  }

  const getCommentCount = e => {
    commRef.onSnapshot((doc) => {
      if (doc.exists) {
        let count = doc.data().count;
        setComments(count);
      }
    })
  }

  function createCounter(ref, num_shards) {
    var batch = db.batch();

    // Initialize the counter document
    batch.set(ref, { num_shards: num_shards });
    console.log('Breakpoint 1');

    // Initialize each shard with count=0
    for (let i = 0; i <= num_shards; i++) {
      console.log('Breakpoint 2');
        let shardRef = ref.collection('shards').doc(i.toString());
        batch.set(shardRef, { count: 0 });
    }

    // Commit the write batch
    return batch.commit();
  }

  React.useEffect(() => {
    getLikesCount();
    getCommentCount();
  }, []);
  return([
    (<Label>
      <Icon name='heart' color='red'/>
      {eventLikes} Likes
    </Label>),
    (<Label>
      <Icon name='comments' color='blue'/>
      {comments} Comments
    </Label>)
  ]);
}
